import { Fragment, useContext } from 'react';

import { View } from 'ol';
import * as olProj from 'ol/proj';

import { ViContext } from '../../context/ViContext';

// import Partition from './Partition';
import SelectWrap from '../selectWrap/SelectWrap';
import ResultWrap from '../resultWrap/ResultWrap';
import CommonMap from './CommonMap';
import WeightedMap from './WeightedMap';

function MapWrapper() {
	const { mapMode } = useContext(ViContext);

	return (
		<div
			className={
				mapMode === 'origin' ? 'partitionWrap origin' : 'partitionWrap weighted'
			}
		>
			<SelectWrap />
			{mapMode === 'origin' ? (
				<Fragment>
					<CommonMap type={'sgg'} />
					<div className="partitionLine" />
					<CommonMap type={'emd'} />
				</Fragment>
			) : (
				<Fragment>
					<WeightedMap />
					<ResultWrap />
				</Fragment>
			)}
		</div>
	);
}

export default MapWrapper;
